import { defineMessages } from 'react-intl';

export default defineMessages({
    activities: {
        id: 'twia.gateway.views.renewal.renewal-activities.Activities',
        defaultMessage: 'Activities',
    },
    activity: {
        id: 'twia.gateway.views.renewal.renewal-activities.Activity',
        defaultMessage: 'Activity',
    },
    searchactivities: {
        id: 'twia.gateway.views.renewal.renewal-activities.Search activities',
        defaultMessage: 'Search activities',
    },
    note: {
        id: 'twia.gateway.views.renewal.renewal-notes.Note',
        defaultMessage: 'Note',
    },
    billingPageLink: {
        id: 'twia.gateway.views.renewal.renewal-summary.If you need to make a payment, please goto...',
        defaultMessage:
            'If you need to make a payment, please go to the {billingPageLink}. If you would like to cancel the renewal please go to the %%policyLink%%.',
    },
    policyStartedSuccessfully: {
        id: 'twia.gateway.views.renewal.renewal-summary.The renewal for this Policy has been successfully started.',
        defaultMessage:
            'The renewal for {lob} Policy {policyNumber} has been successfully started.',
    },
    mayWithdrawRenewal: {
        id: 'twia.gateway.views.renewal.renewal-summary.You may withdraw the renewal',
        defaultMessage: 'You may withdraw the renewal',
    },
    cancelRenewal: {
        id: 'twia.gateway.views.renewal.renewal-summary.Cancel Renewal',
        defaultMessage: 'Cancel Renewal',
    },
    editRenewal: {
        id: 'twia.gateway.views.renewal.renewal-summary.Edit Renewal / Payment Details',
        defaultMessage: 'Edit Renewal / Payment Details',
    },
    premiumRenewalCalculated: {
        id: 'twia.gateway.views.renewal.renewal-summary.The premium for this renewal has been calculated',
        defaultMessage: 'The premium for this renewal has been calculated',
    },
    thisRenewalHasBeenBound: {
        id: 'twia.gateway.views.renewal.renewal-summary.This renewal has been bound',
        defaultMessage: 'This renewal has been bound',
    },
    newPremium: {
        id: 'twia.gateway.views.renewal.renewal-summary.New Premium',
        defaultMessage: 'New Premium',
    },
    transactionSummary: {
        id: 'twia.gateway.views.renewal.renewal-summary.Transaction Summary',
        defaultMessage: 'Transaction Summary',
    },
    increaseOf: {
        id: 'twia.gateway.views.renewal.renewal-summary.Increase of',
        defaultMessage: 'Increase of {value}%',
    },
    totalPremium: {
        id: 'twia.gateway.views.renewal.renewal-summary.Total Premium',
        defaultMessage: 'Total Premium',
    },
    currentPremium: {
        id: 'twia.gateway.views.renewal.renewal-summary.Current Premium',
        defaultMessage: 'Current Premium',
    },
    changeinCost: {
        id: 'twia.gateway.views.renewal.renewal-summary.Change in Cost',
        defaultMessage: 'Change in Cost',
    },
    tax: {
        id: 'twia.gateway.views.renewal.renewal-summary.Tax',
        defaultMessage: 'Tax',
    },
    totalPremiumTaxesandFeesTax: {
        id: 'twia.gateway.views.renewal.renewal-summary.Total Premium + Taxes and Fees(Tax)',
        defaultMessage: '%%totalPremium%% + %%taxesAndFees%% (Tax)',
    },
    createdDate: {
        id: 'twia.gateway.views.renewal.renewal-summary.Created Date',
        defaultMessage: 'Date Created',
    },
    policyInception: {
        id: 'twia.gateway.views.renewal.renewal-summary.Policy Inception',
        defaultMessage: 'Policy Inception',
    },
    status: {
        id: 'twia.gateway.views.renewal.renewal-summary.Status',
        defaultMessage: 'Status',
    },
    policy: {
        id: 'twia.gateway.views.renewal.renewal-summary.Policy',
        defaultMessage: 'Policy',
    },
    renewalEffectiveDate: {
        id: 'twia.gateway.views.renewal.renewal-summary.Renewal Effective Date',
        defaultMessage: 'Renewal Effective Date',
    },
    currentPolicyExpiration: {
        id: 'twia.gateway.views.renewal.renewal-summary.Current Policy Expiration',
        defaultMessage: 'Current Policy Expiration',
    },
    currentPolicy: {
        id: 'twia.gateway.views.renewal.renewal-summary.Current Policy',
        defaultMessage: 'Current Policy',
    },
    viewCurrentPolicy: {
        id: 'twia.gateway.views.renewal.renewal-summary.View Current Policy',
        defaultMessage: 'View Current Policy',
    },
    policybillingpage: {
        id: 'twia.gateway.views.renewal.renewal-summary.policy billing page',
        defaultMessage: 'policy billing page',
    },
    policydetailspage: {
        id: 'twia.gateway.views.renewal.renewal-summary.policy details page',
        defaultMessage: 'policy details page',
    },
    clickEditRenewal: {
        id: 'twia.gateway.views.renewal.renewal-summary.If you need to make a change, click Edit Renewal.',
        defaultMessage: 'If you need to make a change, click Edit Renewal.',
    },
    selectReasonForCancellation: {
        id: 'twia.gateway.views.renewal.renewal-summary.To cancel the renewal, click Cancel Renewal and select a reason for the cancellation.',
        defaultMessage:
            'To cancel the renewal, click Cancel Renewal and select a reason for the cancellation.',
    },
    withdrawRenewalTransaction: {
        id: 'twia.gateway.views.renewal.renewal-summary.If you need to withdraw this renewal transaction, click Withdraw Renewal.',
        defaultMessage:
            'If you need to withdraw this renewal transaction, click Withdraw Renewal.',
    },
    withdrawRenewal: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.Withdraw Renewal',
        defaultMessage: 'Withdraw Renewal',
    },
    renewalNonRendering: {
        id: 'twia.gateway.views.renewal.renewal-summary.This policy has been setup for non-renewal.',
        defaultMessage: 'This policy has been setup for non-renewal.',
    },
    renewalPolicyDraft: {
        id: 'twia.gateway.views.renewal.renewal-summary.The renewal for this policy is draft.',
        defaultMessage:
            'The renewal for policy {policyNumber} is in draft status. To continue with a renewal, please proceed to the Payment Details screen and select either Save & Exit or Submit.',
    },
    renewalPolicyQuoted: {
        id: 'twia.gateway.views.renewal.renewal-summary.The renewal for this policy is quoted.',
        defaultMessage:
            'The renewal for policy {policyNumber} is in quoted status. To continue with a renewal, please proceed to the Payment Details screen and select either Save & Exit or Submit.',
    },
    policyIsBound: {
        id: 'twia.gateway.views.renewal.renewal-summary.The renewal for this policy is now bound.',
        defaultMessage:
            'The renewal for {lob} policy {policyNumber} is now bound.',
    },
    renewalNotTaken: {
        id: 'twia.gateway.views.renewal.renewal-summary.This renewal has not been taken.',
        defaultMessage: 'This renewal has not been taken.',
    },
    renewalWithdrawn: {
        id: 'twia.gateway.views.renewal.renewal-summary.This renewal has been withdrawn.',
        defaultMessage: 'This renewal has been withdrawn.',
    },
    doNotCancel: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.Do Not Cancel',
        defaultMessage: 'Do Not Cancel',
    },
    decidedToAllowRenewPolicy: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.It has been decided not to allow renewal of this policy.',
        defaultMessage:
            'It has been decided not to allow renewal of this policy. The policy will expire on the current expiration date.',
    },
    insurerRequest: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.Insurer Request',
        defaultMessage: 'Insurer Request',
    },
    decidedToDeclineRenewPolicy: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.The customer has decided to decline the renewal of the policy.',
        defaultMessage:
            'The customer has decided to decline the renewal of the policy.',
    },
    customerRequest: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.Customer Request',
        defaultMessage: 'Customer Request',
    },
    sureWithdrawRenew: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.Are you sure you want to withdraw the Renewal?',
        defaultMessage: 'Are you sure you want to withdraw the Renewal?',
    },
    withdrawTheRenewal: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.Withdraw the Renewal?',
        defaultMessage: 'Withdraw the Renewal?',
    },
    reasonForCancellingRenew: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.Reason for Cancelling the Renewal',
        defaultMessage: 'Reason for Cancelling the Renewal',
    },
    cancelCtrlRenewal: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.Cancel Renewal',
        defaultMessage: 'Cancel Renewal',
    },
    doNotWithdraw: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.Do Not Withdraw',
        defaultMessage: 'Do Not Withdraw',
    },
    withdrawCtrlRenewal: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.Withdraw Renewal',
        defaultMessage: 'Withdraw Renewal',
    },
    startedByMistakeNoProblem: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.Was this renewal started by mistake? No problem...',
        defaultMessage:
            'Was this renewal started by mistake? No problem, you can always withdraw the renewal transaction.',
    },
    totalPremiumAndTaxes: {
        id: 'twia.gateway.views.renewal.renewal-summary.Total Premium + Taxes and Fees (Tax)',
        defaultMessage: '{totalPremium} + {taxesAndFees} (Tax)',
    },
    failedToRenewal: {
        id: 'twia.gateway.views.renewal.renewal-summary.Failed to cancel renewal.',
        defaultMessage: 'Failed to cancel renewal.',
    },
    renewalRenewing:{
        id: 'twia.gateway.views.renewal.renewal-summary.The renewal for Commercial Policy <Policy Number> is scheduled for a renewal offer.',
        defaultMessage: 'The renewal for Commercial Policy {policyNumber} is scheduled for a renewal offer.'
    },
    renewalRenewingRes:{
        id: 'twia.gateway.views.renewal.renewal-summary.The renewal for Residential Policy <Policy Number> is scheduled for a renewal offer.',
        defaultMessage: 'The renewal for Residential Policy {policyNumber} is scheduled for a renewal offer.'
    },
    renewalScheduled: {
        id: 'twia.gateway.views.renewal.renewal-summary.The renewal for Commercial Policy has been issued',
        defaultMessage: 'The renewal for Commercial Policy {policyNumber} has been issued'
    },
    renewalScheduledRes: {
        id: 'twia.gateway.views.renewal.renewal-summary.The renewal for Residential policy has been issued',
        defaultMessage: 'The renewal for Residential Policy {policyNumber} has been issued'
    },
    renewalSubmittedCP:{
        id: 'twia.gateway.views.renewal.renewal-summary.A renewal offer has been submitted. The issuance of Commercial Policy is pending payment.',
        defaultMessage: 'A renewal offer has been submitted. The issuance of Commercial Policy {policyNumber} is pending payment.'
    },
    renewalSubmittedHO:{
        id: 'twia.gateway.views.renewal.renewal-summary.A renewal offer has been submitted. The issuance of Residential Policy is pending payment.',
        defaultMessage: 'A renewal offer has been submitted. The issuance of Residential Policy {policyNumber} is pending payment.'
    },
    renewalExpired:{
        id: 'twia.gateway.views.renewal.renewal-summary.This renewal offer has expired.',
        defaultMessage: 'This renewal offer has expired.'
    },
    residentialRenewalDraft:{
        id: 'twia.gateway.views.renewal.renewal-summary.residentialRenewalDraft',
        defaultMessage: 'The renewal for policy {policyNumber} is in draft status. Please review and quote renewal changes. If the changes are not quoted prior to the renewal offer date, all changes will be lost and the offer will be generated based on the expiring policy.',
    },
    residentialRenewalQuoted:{
        id: 'twia.gateway.views.renewal.renewal-summary.residentialRenewalQuoted',
        defaultMessage: 'The renewal for policy {policyNumber} is in quoted status. All quoted changes will be included in the renewal offer.',
    },
});
